import type { WorkOrder } from '@/api/hooks/useWorkOrder'
import type { TranslationKey } from '@/i18n/types'

export type RepairPart = WorkOrder['repairParts'][number]
export type RepairPartStatus = RepairPart['status']
export type RepairPartCategory = RepairPart['categories'][number]

// Actions available on a repair part.
export type RepairAction = 'send' | 'missing'

export const REPAIR_STATUS_LABELS = {
  pending: 'repairParts.status.pending',
  sent_to_paint: 'repairParts.status.sent_to_paint',
  received_at_paint: 'repairParts.status.received_at_paint',
  missing: 'repairParts.status.missing',
  painted: 'repairParts.status.painted',
  assembled: 'repairParts.status.assembled',
} as const satisfies Record<RepairPartStatus, TranslationKey>

export const REPAIR_CATEGORY_LABELS = {
  body: 'repairParts.category.body',
  mechanical: 'repairParts.category.mechanical',
  glass: 'repairParts.category.glass',
  paint: 'repairParts.category.paint',
  plastic: 'repairParts.category.plastic',
  adjustment: 'repairParts.category.adjustment',
} as const satisfies Record<RepairPartCategory, TranslationKey>

// Display order for the category-grouped report (matches the old system's workstation boxes).
export const REPAIR_CATEGORY_ORDER: RepairPartCategory[] = [
  'body',
  'mechanical',
  'glass',
  'paint',
  'plastic',
  'adjustment',
]

// Which parts are eligible for each action, so the multi-select only offers sensible candidates.
export function isSelectableForAction(part: RepairPart, action: RepairAction): boolean {
  switch (action) {
    case 'send':
      // Not already in the paint pipeline.
      return part.status === 'pending' || part.status === 'missing'
    case 'missing':
      return part.status !== 'missing'
  }
}
